import React, { useEffect, useState } from 'react';
import { API_URL, Pipeline } from '../types';
import { useTheme } from '../ThemeContext';
import { apiGet } from '../utils/apiClient';

export default function MainPage() {
  const { theme } = useTheme();
  const [pipelines, setPipelines] = useState<Pipeline[]>([]);
  const [health, setHealth] = useState<'healthy' | 'degraded' | 'down' | 'unknown'>('unknown');
  const [runningJobs, setRunningJobs] = useState<number>(0);

  useEffect(() => {
    const load = async () => {
      try {
        const resP = await apiGet('/api/pipelines');
        const dataP = await resP.json();
        setPipelines(Array.isArray(dataP) ? dataP : []);
      } catch {}

      // Try health endpoint if it exists
      try {
        const resH = await apiGet('/health');
        const dataH = await resH.json();
        setHealth((dataH?.status as any) || 'unknown');
      } catch {
        setHealth('unknown');
      }

      // Try jobs endpoint
      try {
        const resJ = await apiGet('/api/jobs?status=running');
        if (resJ.ok) {
          const dataJ = await resJ.json();
          setRunningJobs(Array.isArray(dataJ) ? dataJ.length : (dataJ?.count ?? 0));
        }
      } catch {}
    };
    load();
  }, []);

  const tile = (title: string, value: React.ReactNode, color: string) => (
    <div style={{ background: theme.cardBackground, borderRadius: 12, padding: 20, boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
      <p style={{ margin: 0, color: theme.textSecondary, fontSize: 12, fontWeight: 600 }}>{title}</p>
      <div style={{ marginTop: 8, fontSize: 28, fontWeight: 700, color }}>{value}</div>
    </div>
  );

  return (
    <div>
      <h2 style={{ marginTop: 0, color: theme.text }}>Overview</h2>
      <p style={{ color: theme.textSecondary, marginTop: 6 }}>Quick glance at system status and activity</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
        {tile('Running Jobs', runningJobs, theme.info)}
        {tile('Health', health.toUpperCase(), health === 'healthy' ? theme.success : health === 'degraded' ? theme.warning : theme.error)}
        {tile('Configured Pipelines', pipelines.length, theme.purple)}
      </div>

      <div style={{ marginTop: 24, background: theme.cardBackground, borderRadius: 12, padding: 20, boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
        <h3 style={{ marginTop: 0, color: theme.text }}>Recent Pipelines</h3>
        <ul style={{ margin: 0, paddingLeft: 18, color: theme.text }}>
          {pipelines.slice(0, 5).map(p => (
            <li key={p.pipeline_id} style={{ marginBottom: 6 }}>
              <span style={{ fontWeight: 600 }}>{p.name}</span>
              <span style={{ color: theme.textSecondary }}> — {p.status}</span>
            </li>
          ))}
          {pipelines.length === 0 && <li style={{ color: theme.textSecondary }}>No pipelines configured yet.</li>}
        </ul>
      </div>
    </div>
  );
}
